import { buildLocale } from './buildLocale';

export const getPriceChangesLabel = (
  currentProductPrice: string | undefined | null,
  orderedPrice: string | undefined | null,
  t: any,
): string => {
  if (!currentProductPrice?.length || !orderedPrice?.length || Number(currentProductPrice) === Number(orderedPrice)) {
    return '';
  }
  const isIncrease = Number(currentProductPrice) > Number(orderedPrice);
  const cssSuffix = isIncrease ? 'up' : 'down';

  return `
      <span class="info-price-box_change-data price-${cssSuffix}">
        <i class="fa fa-long-arrow-${cssSuffix}" aria-hidden="true"></i>
        ${buildLocale(t, isIncrease ? 'priceIncreased' : 'priceDecreased')}
      </span>
    `;
};
